import "bootstrap/dist/css/bootstrap.min.css";
import { Modal } from "react-bootstrap";
import "./Modal.css";
import { IoCloseSharp } from "react-icons/io5";

export default function Model({ btnClick, status, modalname, data, tab }) {
  const validTabs = ["Wing", "Circle", "Division", "Sub-Division", "Subdivision", "Area", "User"];

  return (
    <Modal
      show={status}
      onHide={btnClick}
      centered
      size="sm"
      dialogClassName="region-view-modal"
    >
      <Modal.Body className="bg-white rounded">
        <div className="d-flex justify-content-between align-items-center">
          <h6 className="mb-0 font14 fw-bold">{modalname}</h6>
          <button
            type="button"
            className="btn p-0 text-muted"
            onClick={btnClick}
            aria-label="Close"
          >
            <IoCloseSharp size={18} />
          </button>
        </div>
        <hr className="my-2" />
        <div
          className="region-view-list subdiv-scrollbar"
          style={{
            maxHeight: "240px",
            overflowY: "auto",
            overflowX: "hidden",
            paddingRight: "2px",
          }}
        >
          {data && data.length > 0 && validTabs.includes(tab) ? (
            <ol
              className="mb-0 ps-3 text-start"
              style={{
                listStyleType: "decimal",
                listStylePosition: "outside",
                fontSize: "12.5px",
              }}
            >
              {data.map((item, index) => {
                const text =
                  typeof item === "object" && item !== null
                    ? item.name || item.area || item.subDivision || item.division || item.circle || item.wing || JSON.stringify(item)
                    : String(item);
                return (
                  <li
                    key={`${text}-${index}`}
                    className={`mb-1 text-break ${tab === "Sub-Division" ? "text-dark" : ""}`}
                    style={{
                      display: "list-item",
                      wordBreak: "break-word",
                      overflowWrap: "anywhere",
                      lineHeight: "1.4",
                    }}
                  >
                    {text}
                  </li>
                );
              })}
            </ol>
          ) : (
            <p className="text-center text-muted mb-0 font12 py-2">No data available</p>
          )}
        </div>
      </Modal.Body>
    </Modal>
  );
}
